import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class';
import { connect as connectR } from 'react-redux';
import { Col, Row } from 'react-bootstrap';
import GoogleMap from 'google-map-react';
import translate from '../../translate';
import { GOOGLE_MAPS_API_KEY } from '../../../constants';
import { PbRequest } from '../../../store/pbRequest';

//default to Munich Marienplatz
export const DEFAULT_CENTER = {
    lat: 48.13730536752964,
    lon: 11.57570906249237,
};

const VALIDATORS = {
    position: (position) => position && position.lat && position.lon,
};

const UNSUPPORTED_TIMEZONE = 'UNSUPPORTED_TIMEZONE';

const LocationPositionForm = createReactClass({
    displayName: 'LocationPositionForm',

    propTypes: {
        position: PropTypes.shape({
            lat: PropTypes.number,
            lon: PropTypes.number,
        }),
        handleChange: PropTypes.func.isRequired,
        toggleForm: PropTypes.func,
        forceValidation: PropTypes.bool,
        disabled: PropTypes.bool,
        strings: PropTypes.object,
        updateLocationCall: PropTypes.shape({
            status: PropTypes.string,
            errors: PropTypes.arrayOf(PropTypes.string),
        }).isRequired,
        createLocationCall: PropTypes.shape({
            status: PropTypes.string,
            errors: PropTypes.arrayOf(PropTypes.string),
        }).isRequired,
        refCallback: PropTypes.func,
    },

    defaultProps: {
        position: { ...DEFAULT_CENTER },
        disabled: false,
        forceValidation: false,
        toggleForm: () => {},
        strings: {
            name: 'Position',
        },
        refCallback: undefined,
    },

    getInitialState() {
        const position = { ...DEFAULT_CENTER, ...this.props.position };
        return {
            position,
            defaultCenter: { lat: position.lat, lng: position.lon },
            _valid: true,
        };
    },

    componentWillReceiveProps(nextProps) {
        if (
            JSON.stringify(nextProps.position) !==
            JSON.stringify(this.props.position)
        ) {
            this._handlePositionChange(nextProps.position);
        }
    },

    _handlePositionChange(position) {
        const _valid = VALIDATORS.position(position);
        this.setState({ position, _valid }, () =>
            this.props.handleChange(this.state)
        );
    },

    forward(e) {
        // we need to forward mouse events from the pin to the map, so we can drag the map also starting from above the pin.
        if (this.redispatch) {
            this.redispatch = false;
            return;
        }

        const elementToForwardTo = document.querySelector(
            '[style*="https://maps.gstatic.com/mapfiles/"]'
        );

        const oldEvent = e.nativeEvent;
        const newEvent = new oldEvent.constructor(oldEvent.type, oldEvent);
        this.redispatch = true;

        if (elementToForwardTo) {
            elementToForwardTo.dispatchEvent(newEvent);
        }

        e.stopPropagation();
        e.preventDefault();
        oldEvent.stopImmediatePropagation();
    },

    setMapPosition(position) {
        if (position) {
            this._handlePositionChange(position);
        } else {
            if (this.state.position && this.map) {
                const pos = {
                    lat: this.state.position.lat,
                    lng: this.state.position.lon,
                };
                this.map.setCenter(pos);
            }
        }
    },

    updateRefCallback() {
        if (typeof this.props.refCallback === 'function') {
            this.props.refCallback(this);
        }
    },

    renderError() {
        const errors = [
            ...this.props.createLocationCall.errors,
            ...this.props.updateLocationCall.errors,
        ];

        if (errors.includes(UNSUPPORTED_TIMEZONE)) {
            return (
                <Row>
                    <div className="alert alert-danger pull-right">
                        {this.props.strings.invalidTimezoneError}
                    </div>
                </Row>
            );
        }
        return null;
    },

    render() {
        const stl = { height: 300 };

        clearTimeout(this.centerTimeout);
        this.centerTimeout = setTimeout(() => {
            this.setMapPosition();
        }, 150);

        const disableOverlay = this.props.disabled ? (
            <div className="disabled-overlay" onClick={this.props.toggleForm} />
        ) : null;

        return (
            <div className="location-position-form">
                <div className="details-row">
                    <Col xs={12}>{this.props.strings.details}</Col>
                </div>
                <Row className="map-row">
                    <Col xs={12} style={stl} className="map-wrapper">
                        {disableOverlay}
                        <GoogleMap
                            defaultZoom={17}
                            defaultCenter={this.state.defaultCenter}
                            options={{ fullscreenControl: false }}
                            onGoogleApiLoaded={({ map }) => {
                                this.map = map;
                                this.setMapPosition();

                                this.map.addListener('dragend', () => {
                                    const center = this.map.getCenter();
                                    this._handlePositionChange({
                                        lat: center.lat(),
                                        lon: center.lng(),
                                    });
                                });
                                this.updateRefCallback();
                            }}
                            yesIWantToUseGoogleMapApiInternals
                            bootstrapURLKeys={{
                                key: GOOGLE_MAPS_API_KEY,
                                language: 'eng',
                            }}
                        />
                        <span
                            className="pin"
                            onMouseDown={this.forward}
                            onMouseUp={this.forward}
                            onMouseMove={this.forward}
                            onClick={this.forward}
                        />
                    </Col>
                </Row>
                {this.renderError()}
            </div>
        );
    },
});

export default connectR(
    (store) => ({
        updateLocationCall: store.pbRequest[PbRequest.UPDATE_LOCATION],
        createLocationCall: store.pbRequest[PbRequest.CREATE_LOCATION],
    }),
    {}
)(translate('LocationPositionForm')(LocationPositionForm));
